// We might use JSX to handle the finalActiveOfferFailed/failedOffer if they are the same accross both platforms

const createODSHero = (initialStep, formStep, finalStep, decLogSuppStep) => {
  return offerStep => {
    switch (offerStep) {
      case 'initial':
        return initialStep

      case 'form':
        return formStep

      case 'finalOffer':
        return finalStep

      default:
        return decLogSuppStep
    }
  }
}

export default createODSHero
